import { render, staticRenderFns } from "./vdNewsviewer.vue?vue&type=template&id=1f056dfc&scoped=true&"
import script from "./vdNewsviewer.vue?vue&type=script&lang=js&"
export * from "./vdNewsviewer.vue?vue&type=script&lang=js&"
import style0 from "./vdNewsviewer.vue?vue&type=style&index=0&id=1f056dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../hastrid-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f056dfc",
  null
  
)

export default component.exports